import getQueryVariable from '~/adapters/browser/getQueryVariable';

export const getAccountIdQueryVariable = () => {
    return getQueryVariable('accountId', { tryDecode: false });
};
